import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import { rem } from 'polished';
import screen from 'superior-mq';
import Container from '../../container';
import Subhead from '../../subhead';
import Section from '../../section';
import AboutContentDiv from '../about-content-div';
import RenderMd from '../../render-md';

const AboutIntro = ({ subheading, title, content, id }) => (
  <Section id={id}>
    <Container>
      <AboutIntroStatement>

        <AboutSubhead>{subheading}</AboutSubhead>
        <AboutIntroHeadline>{title}</AboutIntroHeadline>
        <RenderMd source={content} />

      </AboutIntroStatement>
    </Container>
  </Section>
);

const AboutIntroStatement = styled(AboutContentDiv)`
  max-width: 674px;
  margin: auto;
  text-align: left;
`;

const AboutIntroHeadline = styled.h3`
  ${screen.below(bp.mobile, `
    max-width: 298px;
    font-size: ${rem(27)};
  `)};
`;

const AboutSubhead = styled(Subhead)`
  text-align: left;
`;

AboutIntro.propTypes = {
  subheading: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  id: PropTypes.string,
};

export default AboutIntro;
